import React, { useState } from 'react';
import EmailEditPresenter from './EmailEditPresenter';
import { useSnackbar } from 'notistack';
import { STORAGE_ACTION, getStorageItem } from '@utils/storage';
import {
  CapaErrorCode,
  CapaServiceType,
  useRequestEmailVerificationCodeMutation
} from '@generated/graphql';

interface Props {
  onSubmit: (_: any) => void;
  onCancel: () => void;
}

const EmailEditContainer = ({ onSubmit, onCancel }: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isSendVerficationCode, setIsSendVerficationCode] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const isGhost = getStorageItem(STORAGE_ACTION.IS_GHOST_CLIENT);
  const [
    requestEmailVerificationCode
  ] = useRequestEmailVerificationCodeMutation();

  const onEmailVerficationClick = (email?: string) => {
    if (isGhost && isGhost === 'true') return;
    setIsSendVerficationCode(true);

    requestEmailVerificationCode({
      variables: {
        email: email ?? '',
        service: CapaServiceType.Quotation
      }
    }).then((result) => {
      switch (result.data?.requestEmailVerificationCode.result) {
        case CapaErrorCode.Success:
          setIsAuth(true);
          enqueueSnackbar('인증메일이 발송되었습니다.', {
            variant: 'success'
          });
          break;
        case CapaErrorCode.DuplicateEmail:
          enqueueSnackbar('이미 가입된 이메일입니다.', {
            variant: 'error'
          });
          break;
        default:
          enqueueSnackbar('인증메일 발송에 실패했습니다.', {
            variant: 'error'
          });
      }
    });
  };

  return (
    <EmailEditPresenter
      onEmailVerficationClick={onEmailVerficationClick}
      isSendVerficationCode={isSendVerficationCode}
      onSubmit={onSubmit}
      onCancel={onCancel}
      isAuth={isAuth}
    />
  );
};

export default EmailEditContainer;
